import request from '@/request/utilsRequest'
import { removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
// 验证多个表单
export function validateAllForm(vm, arr) {
  return new Promise(function(resolve, reject) {
    var resultArr = []
    function checkForm(formName) {
      var result = new Promise(function(resolve, reject) {
        vm.$refs[formName].validate((valid) => {
          if (valid) {
            resolve()
          } else { reject() }
        })
      })
      resultArr.push(result)
    }
    arr.forEach(item => {
      checkForm(item)
    })
    Promise.all(resultArr).then(() => {
      resolve(true)
    }).catch(() => {
      reject(false)
    })
  })
}
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
export function getuuid() {
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
}
export function isPC() {
  const userAgentInfo = navigator.userAgent
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ]
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}
var writeUTF = function(str, isGetBytes) {
  var back = []
  var byteSize = 0
  for (var i = 0; i < str.length; i++) {
    var code = str.charCodeAt(i)
    if (code >= 0x00 && code <= 0x7f) {
      byteSize += 1
      back.push(code)
    } else if (code >= 0x80 && code <= 0x7ff) {
      byteSize += 2
      back.push((192 | (31 & (code >> 6))))
      back.push((128 | (63 & code)))
    } else if ((code >= 0x800 && code <= 0xd7ff) ||
      (code >= 0xe000 && code <= 0xffff)) {
      byteSize += 3
      back.push((224 | (15 & (code >> 12))))
      back.push((128 | (63 & (code >> 6))))
      back.push((128 | (63 & code)))
    }
  }
  for (i = 0; i < back.length; i++) {
    back[i] &= 0xff
  }
  if (isGetBytes) {
    return back
  }
  if (byteSize <= 0xff) {
    return [0, byteSize].concat(back)
  } else {
    return [byteSize >> 8, byteSize & 0xff].concat(back)
  }
}

var readUTF = function(arr) {
  if (typeof arr === 'string') {
    return arr
  }
  var UTF = ''; var _arr = arr
  for (var i = 0; i < _arr.length; i++) {
    var one = _arr[i].toString(2)
    var v = one.match(/^1+?(?=0)/)
    if (v && one.length === 8) {
      var bytesLength = v[0].length
      var store = _arr[i].toString(2).slice(7 - bytesLength)
      for (var st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2)
      }
      UTF += String.fromCharCode(parseInt(store, 2))
      i += bytesLength - 1
    } else {
      UTF += String.fromCharCode(_arr[i])
    }
  }
  return UTF
}

export function stringToHex(str) {
  var charBuf = writeUTF(str, true)
  var re = ''
  for (var i = 0; i < charBuf.length; i++) {
    var x = (charBuf[i] & 0xFF).toString(16)
    if (x.length === 1) {
      x = '0' + x
    }
    re += x
  }
  return re
}
export function hexToString(str) {
  var buf = []
  for (var i = 0; i < str.length; i += 2) {
    buf.push(parseInt(str.substring(i, i + 2), 16))
  }
  return readUTF(buf)
}
// excel导出
export function excelExport(result) {
  return new Promise((resolve, reject) => {
    if (result.data.type === 'application/json') {
      const reader = new FileReader()
      reader.readAsText(result.data, 'utf-8')
      reader.onload = function() {
        const newJson = JSON.parse(reader.result)
        if (newJson.code !== 2000) {
          Message.error(newJson.message)
          if (newJson.code === 9001) {
            setTimeout(() => {
              removeToken()
              window.location.reload()
            }, 2000)
          }
        }
      }
    } else {
      const filename = decodeURIComponent(result.headers['content-disposition'].split(';')[1].split('=')[1])
      if (!!window.ActiveXObject || 'ActiveXObject' in window) return window.navigator.msSaveOrOpenBlob(result.data, filename)
      const url = URL.createObjectURL(result.data)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      resolve()
      link.click()
    }
  })
}
// 附件信息下载
export function downloadAttachment(data) {
  request.getDocument(data).then(res => {
    if (res.code === 2000) {
      const result = res.data
      if (!result.includes('http')) {
        Message.error('无效的附件地址')
        return
      }
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = result
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    } else {
      Message.error(res.message)
    }
  })
}

export function test22(str) {
  const bold = base64ToBlob(str)
  const url = window.URL.createObjectURL(bold)
  const aDom = document.createElement('a')
  aDom.href = url
  aDom.style.display = 'none'
  aDom.download = `ces.png`
  document.body.appendChild(aDom)
  aDom.click()
  document.body.removeChild(aDom)
}

export async function downloadAttachmentForBlob(data, row) {
  try {
    const res = await request.getDocument(data)
    if (res.code === 2000) {
      const bold = base64ToBlob(res.data)
      const url = window.URL.createObjectURL(bold)
      const aDom = document.createElement('a')
      aDom.href = url
      aDom.style.display = 'none'
      aDom.download = `${row.invoiceType}.png`
      document.body.appendChild(aDom)
      aDom.click()
      document.body.removeChild(aDom)
    } else {
      Message.error(res.message)
    }
  } catch (e) {
    console.log(e)
  }
}

export async function downloadAttachmentForBlob2(data, row) {
  try {
    const res = await request.getDocumentBlob(data)
    if (res.code === 2000) {
      const bold = base64ToBlob(res.data)
      const url = window.URL.createObjectURL(bold)
      const aDom = document.createElement('a')
      aDom.href = url
      aDom.style.display = 'none'
      aDom.download = `${row.invoiceType}.png`
      document.body.appendChild(aDom)
      aDom.click()
      document.body.removeChild(aDom)
    } else {
      Message.error(res.message)
    }
  } catch (e) {
    console.log(e)
  }
}

// * desc: base64对象转blob文件对象
// * @param urlData  ：数据的base64对象
// * @returns {Blob}：Blob文件对象
function base64ToBlob(urlData) {
  // 去掉url的头，并转化为byte
  const bytes = window.atob(urlData)
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length)
  // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], {
    type: 'png'
  })
}

export function getTableData(data) {
  let arr = []
  if (isPC()) {
    arr = [{
      label1: '资格证号：',
      value1: data.customerId,
      label2: '发票月份：',
      value2: data.chargeMonth
    }, {
      label1: '中文姓名：',
      value1: data.customerName,
      label2: '经办店铺：',
      value2: data.transactStoreName
    }, {
      label1: '商户名称：',
      value1: data.oldTradeName,
      label2: '最新商户名称：',
      value2: data.tradeName
    }, {
      label1: '付款方：',
      value1: data.company,
      label2: '纳税人识别号：',
      value2: data.businessLicense
    }, {
      label1: '申请服务费：',
      value1: data.chargeAmount,
      label2: '申请小时数：',
      value2: data.hours
    }, {
      label1: '实际服务费：',
      value1: data.declareAmount,
      label2: '实际小时数：',
      value2: data.declareHours
    }]
  } else {
    arr = [
      {
        label1: '资格证号：',
        value1: data.customerId
      }, {
        label1: '发票月份：',
        value1: data.chargeMonth
      }, {
        label1: '中文姓名：',
        value1: data.customerName
      }, {
        label1: '经办店铺：',
        value1: data.transactStoreName
      }, {
        label1: '商户名称：',
        value1: data.oldTradeName
      }, {
        label1: '最新商户名称：',
        value1: data.tradeName
      }, {
        label1: '付款方：',
        value1: data.company
      }, {
        label1: '纳税人识别号：',
        value1: data.businessLicense
      }, {
        label1: '申请服务费：',
        value1: data.chargeAmount
      }, {
        label1: '申请小时数：',
        value1: data.hours
      }, {
        label1: '实际服务费：',
        value1: data.declareAmount
      }, {
        label1: '实际小时数：',
        value1: data.declareHours
      }]
  }
  return arr
}

export function getUrlAddU(url) {
  if (process.env.NODE_ENV === 'uat') {
    url = url.replace(url.split('/')[4], url.split('/')[4] + 'u')
  }
  return url
}
